import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    -webkit-touch-callout: none;
  }
`

export default GlobalStyle
